import React from 'react';
import ModuleComplianceBox from './ModuleComplianceBox';
import SummaryOfAlertChart from './SummaryOfAlertsChart';

const SummaryOverview = ({ modules ,summaryOfAlerts}) => {
  // Default modules if not provided
  const defaultModules = [
    { name: 'Helmet', compliance: 100, nonCompliance: 80, cameras: 34 },
    { name: 'MMHE', compliance: 100, nonCompliance: 40, cameras: 21 },
    { name: 'Emergency Exit', compliance: 100, nonCompliance: 38, cameras: 2 },
    { name: 'Vest', compliance: 99.9, nonCompliance: 58, cameras: 16 }
  ];

  const displayModules = modules;

  return (
    <div style={{ marginBottom: '30px' }}>
      <h3 style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '15px' }}>Summary Overview</h3>
      
      <div style={{ display: 'flex', gap: '30px' }}>
        {/* Left Column - Summary of Alerts */}
        <div style={{ flex: '1' }} className='p-3 border b-r-10'>
          <h4 style={{ fontSize: '16px', fontWeight: 'bold', marginBottom: '10px' }}>Summary of Alerts</h4>
          <SummaryOfAlertChart data={summaryOfAlerts} />
          {/* <div style={{ display: 'flex', alignItems: 'flex-end', height: '150px', gap: '15px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '60px' }}>
              <div style={{ backgroundColor: '#2e8b57', width: '40px', height: '50px' }}></div>
              <p style={{ margin: '5px 0 0', fontSize: '12px' }}>High</p>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '60px' }}>
              <div style={{ backgroundColor: '#e74c3c', width: '40px', height: '70px' }}></div>
              <p style={{ margin: '5px 0 0', fontSize: '12px' }}>Medium</p>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '60px' }}>
              <div style={{ backgroundColor: '#f39c12', width: '40px', height: '100px' }}></div>
              <p style={{ margin: '5px 0 0', fontSize: '12px' }}>Low</p>
            </div>
          </div> */}
        </div>

        {/* Right Column - Module Compliance Overview */}
        <div style={{ flex: '1' }} className='p-3 border b-r-10'>
          <ModuleComplianceBox modules={displayModules} />
        </div>
      </div>
    </div>
  );
};

export default SummaryOverview;